import { render, staticRenderFns } from "./viewAudit.vue?vue&type=template&id=228535f3&scoped=true&"
import script from "./viewAudit.vue?vue&type=script&lang=js&"
export * from "./viewAudit.vue?vue&type=script&lang=js&"
import style0 from "./viewAudit.vue?vue&type=style&index=0&id=228535f3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228535f3",
  null
  
)

export default component.exports